module.exports = __webpack_public_path__ + "img/merkle-animation.4b48f136.gif";